import React from "react"
import { Layout } from "~/src/components"
import { Header, Video } from "planetyze-ui"
import { graphql } from "react-apollo"
import query from "./Internal.gql"
import getContext from "context"

const Internal = props => {
  const { t } = getContext()

  return (
    <Layout.Loader {...props.data}>
      {({ guidebook }) => {
        const path = [
          { label: t("japan"), url: "/" },
          { label: guidebook.location.name, url: guidebook.location.url }
        ]

        const params = {
          guidebook: guidebook.title,
          location: guidebook.location.name
        }

        return (
          <Layout
            title={t("seo.location-internal.title", params)}
            description={t("seo.location-internal.description", params)}
            pageType="internal"
            url={props.uri}>
            <div className="container mx-auto max-w-lg">
              <Header
                title={guidebook.title}
                className="mb-8"
                titleClass="text-5xl lg:text-6xl"
                path={path}
              />
              <div className="text-2xl leading-normal mb-20">
                {guidebook.description}
              </div>

              {guidebook.video && (
                <Video code={guidebook.video.code} className="mb-20" />
              )}

              <div
                id="root"
                className="blog-content"
                dangerouslySetInnerHTML={{
                  __html: guidebook.content.replace("<p>&nbsp;</p>", "")
                }}
              />
            </div>
          </Layout>
        )
      }}
    </Layout.Loader>
  )
}

export default graphql(query, {
  options: props => {
    let page = props.uri.split("/")
    page = page[page.length - 1]

    return {
      variables: {
        guidebook: page,
        location: props.slug
      }
    }
  }
})(Internal)
